import { create } from "zustand";

export interface AuthStore {
  token: string | null;
  userId: string | null;
  setToken: (token: string | null) => void;
  setUserId: (userId: string | null) => void;
}

export const useAuth = create<AuthStore>((set) => ({
  token: null,
  userId: null,
  setToken: (token: string | null) => set({ token }),
  setUserId: (userId: string | null) => set({ userId })
}));

